import React, {Component } from 'react';
import Banner from "./Banner";
import Intro from "./Intro";
import CityTiles from "./CityTiles";
import {cityList} from "./cities/Cities";

const TITLE = "Different Area, Same Hunt (DASH)";
const INTRO_TEXT = "DASH (Different Area, Same Hunt) is a fun, interactive event where teams of players race to find and" +
"solve creative content hidden in different locations in cities all over the world." +
"From fictitious graveyards to s'mores designed in Morse code to music clips containing a hidden message," +
"anything is possible to encounter when playing in the DASH puzzle hunt.";

class HomePage extends Component {
  render() {
    return (
        <div>
          <a name="intro" />
          <Intro title={TITLE} text={INTRO_TEXT}/>
          <Banner />
          <a name="locations" />
          <CityTiles cities={cityList} />
          <script>
            initBanner();
          </script>
        </div>
    );
  }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/HomePage.js